import React, { useEffect, useState, Fragment } from 'react';
import axios from 'axios';
import { Formik, useFormik, Field, FieldArray } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faAngleDown } from '@fortawesome/free-solid-svg-icons';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import Dialog from '@material-ui/core/Dialog';
import Input from '@material-ui/core/Input';
import { Grid } from '@material-ui/core';
// import Select from '@material-ui/core/Select';
// import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import token from '../../config/token';
import { CommonConfig } from '../../config/common-config';
import LoaderPopUp from '../../components/loaderpopup/loader';
import SuccessPopUp from '../../components/loaderpopup/success';
import ErrorPopUp from '../../components/loaderpopup/error';

const useStyles = makeStyles((theme) => ({
    btnbottom: {
        borderBottom: '#feef6',
    },

    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
            width: '100%',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileNameMargin: {
        marginTop: '6px',
        marginBottom: '0px',
    },
    flexRow: {
        flexDirection: 'row !important',
    },
    removeButton: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        marginRight: '15px !important',
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '6px',
    },
    imgView: {
        borderRadius: '8px',
        marginLeft: '12px',
        background: '#e8e7e7',
        padding: '6px 0px 5px 10px',
        marginBottom: '10px',
    },
    searchClient: {
        borderBottom: 'none !important',
        background: '#eaeaf4',
        padding: '6px 2px 0px 9px',
        borderRadius: '5px',
        '& .MuiInput-underline:after': {
            border: 'none',
        },
        '& .MuiIconButton-label': {
            marginTop: '-2px !important',
        },
    },
    clientView: {
        padding: '12px 18px 15px 12px',
        marginBottom: '16px !important',
    },
    labelView: {
        marginBottom: '6px',
        fontWeight: '500',
        color: '#4c4c4dd1 !important',
        fontSize: '15px !important',
        fontFamily: 'Rubik',
    },
}));

export default function AddGenericInvoice(props) {
    const classes = useStyles();
    // const dispatch = useDispatch({});
    // const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    // const [showLoaderSave, setShowLoaderSave] = useState(false);
    // const [success, setSuccess] = useState(false);
    // const [successpopsubmit, setSuccessPopSubmit] = useState(false);
    // const [error, setError] = useState(false);
    // const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    // const [state, setState] = React.useState({
    //     checkedA: true,
    // });

    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);

    // const [filename, setFilename] = useState('');
    // const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    // const [isDisable, setIsDisable] = useState(true);
    // const [isfileInvalid, setIsfileInvalid] = useState('');
    // const [selectedFileData, setSelectedFileData] = useState(null);
    // const [URLValue, setURLValue] = useState();
    // const [URLValueData, setURLValueData] = useState([]);
    // const [handleOpen, setHandleOpen] = useState(false);
    // const [clearData, setClearData] = useState('');
    // const [attachedFilename, setAttachedFilename] = useState('');
    // const [uploadDisable, setUploadDisable] = useState(true);
    // const [fileIndex, setFileIndex] = useState();
    // const [visible, setVisible] = React.useState(false);
    // const coreFilename = [];
    // const [downloadFile, setDownloadFile] = useState('');
    // const [IMCIndex, setIMCIndex] = useState('');
    // const [attachedFileIMC, setAttachedFileIMC] = useState('');
    // const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    // const userToken = tempToken && tempToken.data.token;
    // const bearerToken = `Bearer ${userToken}`;
    // const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    // const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    // const imcdraftsavevalue = useSelector((state) => state.draftreducer.imcdraftsave);
    // const imcdraftsavevalue1 = imcdraftsavevalue && imcdraftsavevalue.params;
    // const imcdraftsavevalue2 = imcdraftsavevalue1 && imcdraftsavevalue1.draftDocuments;
    // const [fileList, setFileList] = useState([]);
    // const UploadFileList = [];
    // let dateValue = new Date().toISOString().split('T')[0];
    // const [checklist, setChecklist] = useState([]);
    // const [IMCList, setIMCList] = useState([]);
    // const tempArr = [];
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const tokens = token();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const [totalClient, setTotalClient] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    const initialValues = {};

    initialValues.invoiceList = [
        {
            particulars: '',
            amount: '',
            description: '',
        },
    ];

    const validationSchema = Yup.object().shape({
        invoiceList: Yup.array().of(
            Yup.object().shape({
                particulars: Yup.string().nullable().required('Required Field'),
                amount: Yup.string()
                    .nullable()
                    .matches(/^[0-9\,]+$/, 'Please Enter digits only')
                    .required('Required Field'),
                description: Yup.string(),
                // .nullable()
                // .required('Required Field'),
            })
        ),
        client: Yup.string(),
    });

    const navigateBack = () => {
        if (usertype === 'Admin' || usertype === 'Support Team') {
            history.push({
                pathname: '/menu/indInvoice',
            });
        } else {
            history.push({
                pathname: '/menu/Invoices',
            });
        }
    };

    //append comma for amount textfield
    const handleStateChange = (e) => {
        const {
            target: { value },
        } = e;
        if (value.length && !isNaN(parseFloat(value))) {
            const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(value.replace(/,/g, '')));
            e.target.value = IndianCur;
        } else {
            e.target.value = value;
        }
    };

    const handleSubmit = (values) => {
        setShowLoader(true);
        // setSuccessPop(true);
        let tempArr = [];
        values.invoiceList.filter((ele, i) => {
            let temp = {
                particularsText: ele.particulars,
                amountForInvoice: ele.amount.replace(/,/g, ''),
                descriptionForInvoice: ele.description,
            };
            tempArr.push(temp);
        });
        // console.log('values', values, selectedClient)
        let tempObj = {
            clientType: selectedClient.clientType,
            clientId: selectedClient.clientId,
            clientName: selectedClient.clientName,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: [],
                itrAcknowledgement: '',
                taxChalanOrAcknowledgement: '',
                transferchallan: null,
                transferToAccount: null,
                payonline: null,
                stage: 'null',
                paidTax: null,
                particulars: tempArr,
                reports: '',
                createdBy: null,
                modifiedBy: '',
                dateCreated: null,
                dateModified: null,
                requestedEmpName: null,
                requestedEmpLastName: null,
                requestedEmpId: 0,
            },
            finalDocAndReports: null,
        };
        // console.log('tempObj', tempObj)

        axios
            .post(`${CommonConfig.dev.baseUrl1}/api/auth/request-generic-invoice/${dbname}`, tempObj, tokens)
            .then((response) => {
                if (response.data === 'SUCCESS') {
                    setShowLoader(false);
                    setSuccessPop(true);
                    // console.log('response')
                    setTimeout(() => {
                        if (usertype === 'Admin' || usertype === 'Support Team') {
                            history.push({
                                pathname: '/menu/indInvoice',
                            });
                        } else {
                            history.push({
                                pathname: '/menu/Invoices',
                            });
                        }
                    }, 3000);
                }
            })
            .catch((error) => {
                setShowLoader(false);
                setErrorPop(true);
                const errResult = error.response;
                if (errResult && errResult.data) {
                }
                setTimeout(() => {
                    setErrorPop(false);
                }, 5000);
                setErrorMsgGenerateRecceipt(errResult.data.message);
            });
    };

    useEffect(() => {
        axios.get(`${CommonConfig.dev.baseUrl}/api/auth/list-IndAndCorp-clients/${dbname}`, tokens).then((response) => {
            // console.log('Responseeeeeee', response.data);
            setTotalClient(response.data);
        });
        // console.log("usertype", usertype);
    }, [tokens]);

    const setChooseClientsID = (e) => {
        // console.log('clientData', e)
        if (e !== undefined && e !== null && e !== '') {
            const clientData = e.split('-');
            // setClientId(clientData[1]);
            totalClient.filter((ele) => {
                let name = ele.clientId + ' ' + ele.clientName + ' ' + ele.clientLastName + ' ' + `(${ele.clientType})`;
                // console.log("name3", name);
                let name2 = Number(clientData[0]) + '' + clientData[1];
                // console.log("name2", name2);
                if (name === name2) {
                    // console.log("ele399", ele);
                    return setSelectedClient(ele);
                }
            });
        }
    };

    const returnClients = (clientArr) => {
        // console.log('clientArr', clientArr);
        const OptionList = clientArr.map((data) => {
            return `${data.clientId} - ${data.clientName} ${data.clientLastName} (${data.clientType})`;
        });
        return OptionList;
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Request for invoice submitted" /> : null}
            {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}

            <div>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => handleSubmit(values)}
                    enableReinitialize
                >
                    {(formik) => {
                        return (
                            <form className="itecform" onSubmit={formik.handleSubmit}>
                                {/* <Card className={classes.root}> */}
                                <Card className="clientcard">
                                    <CardContent className="client-heading">
                                        <Typography variant="h5">Request Generic Invoice</Typography>
                                    </CardContent>
                                    <CardContent>
                                        <Card className={classes.clientView}>
                                            <Grid item xs={12} sm={12}>
                                                <InputLabel className={classes.labelView} htmlFor="services">
                                                    Select Client
                                                </InputLabel>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        className={classes.searchClient}
                                                        name="ultimateClientId"
                                                        onChange={(event, value) => {
                                                            setChooseClientsID(value);
                                                            // formik.handleChange(value);
                                                        }}
                                                        // SingleValue={selectedChooseClientID}
                                                        freeSolo
                                                        value={formik.values.clientId}
                                                        id="combo-box-demo"
                                                        options={returnClients(totalClient)}
                                                        style={{ width: '100%' }}
                                                        renderInput={(params) => <TextField {...params} placeholder="Search..." />}
                                                    />

                                                    {formik.touched.ultimateClientId && formik.errors.ultimateClientId ? (
                                                        <span className="serviceformError">{formik.errors.ultimateClientId}</span>
                                                    ) : null}
                                                </FormControl>
                                            </Grid>
                                        </Card>
                                        <Card className="p20 bxshadow">
                                            <Grid container xs={12} sm={12} spacing={3}>
                                                <Grid container spacing={3} className="main-container">
                                                    <FieldArray name="invoiceList">
                                                        {(fieldArrayProps) => {
                                                            const { push, remove, form } = fieldArrayProps;
                                                            const { values } = form;
                                                            const { invoiceList } = values;
                                                            let key = 0;

                                                            return (
                                                                <>
                                                                    {invoiceList.map((item, invoiceindex) => {
                                                                        key++;
                                                                        return (
                                                                            <Fragment key={key}>
                                                                                {invoiceindex > 0 && (
                                                                                    <div className="field-divider">
                                                                                        {' '}
                                                                                        <hr />
                                                                                    </div>
                                                                                )}
                                                                                <Grid item xs={12} sm={12}>
                                                                                    <FormControl fullWidth className={classes.margin}>
                                                                                        <InputLabel htmlFor="bank-name" shrink>
                                                                                            Particular{' '}
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field
                                                                                            name={`invoiceList[${invoiceindex}].particulars`}
                                                                                        >
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;

                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            className={classes.bottomLine}
                                                                                                            id="particulars"
                                                                                                            placeholder="Enter Particular"
                                                                                                            name="particulars"
                                                                                                            disabled={
                                                                                                                usertype ===
                                                                                                                'Other employee users'
                                                                                                            }
                                                                                                            {...field}
                                                                                                        />
                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>

                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth className={classes.margin}>
                                                                                        <InputLabel htmlFor="bank-name" shrink>
                                                                                            Amount{' '}
                                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                                        </InputLabel>
                                                                                        <Field name={`invoiceList[${invoiceindex}].amount`}>
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;

                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            className={classes.bottomLine}
                                                                                                            onInput={(e) =>
                                                                                                                handleStateChange(e)
                                                                                                            }
                                                                                                            id="amount"
                                                                                                            placeholder="Enter Amount"
                                                                                                            name="amount"
                                                                                                            disabled={
                                                                                                                usertype ===
                                                                                                                'Other employee users'
                                                                                                            }
                                                                                                            {...field}
                                                                                                        />
                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <FormControl fullWidth className={classes.margin}>
                                                                                        <InputLabel htmlFor="bank-name" shrink>
                                                                                            Description
                                                                                        </InputLabel>
                                                                                        <Field
                                                                                            name={`invoiceList[${invoiceindex}].description`}
                                                                                        >
                                                                                            {(fieldProps) => {
                                                                                                const { field, meta } = fieldProps;

                                                                                                return (
                                                                                                    <>
                                                                                                        <Input
                                                                                                            className={classes.bottomLine}
                                                                                                            id="description"
                                                                                                            placeholder="Enter Description"
                                                                                                            name="description"
                                                                                                            disabled={
                                                                                                                usertype ===
                                                                                                                'Other employee users'
                                                                                                            }
                                                                                                            {...field}
                                                                                                        />
                                                                                                        {meta.touched && meta.error ? (
                                                                                                            <span className="itec-validationError">
                                                                                                                {meta.error}
                                                                                                            </span>
                                                                                                        ) : null}
                                                                                                    </>
                                                                                                );
                                                                                            }}
                                                                                        </Field>
                                                                                    </FormControl>
                                                                                </Grid>
                                                                                <span className="add-remove">
                                                                                    <div className="addmore">
                                                                                        {invoiceindex === invoiceList.length - 1 && (
                                                                                            <Button
                                                                                                variant="outlined"
                                                                                                color="primary"
                                                                                                className="txt-capitalize"
                                                                                                onClick={() => {
                                                                                                    push({
                                                                                                        particulars: '',
                                                                                                        amount: '',
                                                                                                        description: '',
                                                                                                    });
                                                                                                }}
                                                                                                disabled={
                                                                                                    usertype === 'Other employee users'
                                                                                                }
                                                                                            >
                                                                                                Add More
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="removemore">
                                                                                        {invoiceList.length !== 1 && (
                                                                                            <Button
                                                                                                variant="outlined"
                                                                                                color="primary"
                                                                                                className="txt-capitalize "
                                                                                                onClick={() => {
                                                                                                    remove(invoiceindex);
                                                                                                }}
                                                                                                disabled={
                                                                                                    usertype === 'Other employee users'
                                                                                                }
                                                                                            >
                                                                                                Remove
                                                                                            </Button>
                                                                                        )}
                                                                                    </div>
                                                                                </span>
                                                                            </Fragment>
                                                                        );
                                                                    })}
                                                                </>
                                                            );
                                                        }}
                                                    </FieldArray>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </CardContent>
                                </Card>

                                <div className="footer-button">
                                    <ul>
                                        <li>
                                            <Button color="primary" className="buttonnext txt-cap" onClick={() => navigateBack()}>
                                                {' '}
                                                Back
                                            </Button>
                                        </li>
                                        <li>
                                            <Button
                                                color="primary"
                                                className="buttonnext txt-cap"
                                                type="submit"
                                                disabled={usertype === 'Other employee users'}
                                            >
                                                Submit
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </div>
        </>
    );
}
